import v2_actionFiltrosProdutos from './v2_actionFiltrosProdutos';
import Actions from '../../../constants/Actions';

// Valores distintos de departamento/griffe/grupo/subgrupo para o termo atual
// (ou o catálogo inteiro, sem termo). É o que popula os dropdowns antes de
// existir resultado e evita que as opções encolham a cada filtro aplicado.
// Só refaz a chamada quando o termo muda — o backend também cacheia.
let ultimoTermo = null;

const carregarFacetsProdutos = async (dispatch, { search, force = false } = {}) => {
    const termo = String(search || '').trim();
    if (!force && termo === ultimoTermo) return;
    ultimoTermo = termo;
    try {
        const querys = termo ? `?search=${encodeURIComponent(termo)}` : '';
        const response = await v2_actionFiltrosProdutos(querys);
        if (response && response.status === 200 && response.data) {
            dispatch({
                type: Actions.SET_FILTER_FACETS,
                filterFacets: { search: termo, ...response.data }
            });
        }
    } catch (err) {
        ultimoTermo = null;
        console.error('Erro ao carregar opções de filtro:', err);
    }
};

export default carregarFacetsProdutos;
